import React from "react";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../shared/popup-card.scss";

interface ClaimPolicyInquiryProps {
  visible: boolean;
  policyNumber: string;
  onPolicyNumberChange: (value: string) => void;
  onSubmit: () => void;
}

export const ClaimPolicyInquiry: React.FC<ClaimPolicyInquiryProps> = ({
  visible,
  policyNumber,
  onPolicyNumberChange,
  onSubmit,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  const disabled = !policyNumber.trim();

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <h3 className="popup-title">استعلام عن وثيقة</h3>
        <p className="popup-subtitle">أدخل رقم الوثيقة المرتبطة بسيارتك</p>
        <input
          type="text"
          value={policyNumber}
          onChange={(e) => onPolicyNumberChange(e.target.value)}
          placeholder="أدخل رقم الوثيقة"
          className="popup-input"
        />
        <p className="popup-hint">
          يمكنك إيجاد الرقم على بطاقتك الرقمية أو في الزاوية العلوية اليمنى من وثيقة التأمين
        </p>
        <button
          onClick={onSubmit}
          disabled={disabled}
          className="popup-btn-primary"
        >
          🔍 بحث عن الوثيقة
        </button>
      </div>
    </div>
  );
};
